import { useDocSnapshot, useQuerySnapshot, useMissionControlDB, } from "@aglocal/web/firebase";
import UniqueList from "@aglocal/web/helpers/UniqueList";
import { useMemo } from "react";
const DEFAULT_EXCLUDED_CONFIDENCE = [
    "Intermediate",
    "Advanced",
    "Unknown",
    "Some",
    "Novice",
];
export default function useSkillClassifier(id, exclude = DEFAULT_EXCLUDED_CONFIDENCE) {
    const db = useMissionControlDB();
    const tempOutput = useQuerySnapshot(db.skillclassifierTemp.subcollections(id).skills.query());
    const modelOutput = useDocSnapshot(db.modelOutput.doc(id));
    const result = useMemo(() => {
        const skills = new UniqueList(null, ({ skill }) => skill);
        const addSkill = (skill) => {
            if (exclude.includes(skill.confidence)) {
                return;
            }
            skills.add(skill);
        };
        modelOutput.snapshot?.data()?.skillclassifier?.responses.forEach(addSkill);
        tempOutput.snapshot?.forEach((doc) => {
            addSkill(doc.data());
        });
        return Array.from(skills);
    }, [exclude, modelOutput.snapshot, tempOutput.snapshot]);
    return [
        result,
        modelOutput.loading || tempOutput.loading,
        modelOutput.error ?? tempOutput.error,
    ];
}
